import assign from 'lodash/assign';
import forEach from 'lodash/forEach';
import sanitizer from 'sanitizer';

var queryUtil = {
  sanitize(obj = {}) {
    let newQueryObj = {};

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key]) {
        const queryValue = obj[key];

        newQueryObj[encodeURIComponent(key)] = encodeURIComponent(sanitizer.sanitize(queryValue));
      }
    }

    return newQueryObj;
  },
  stringify(obj) {
    var str = [];

    forEach(obj, (v, k) => {
      if (v || v === false || v === 0) {
        str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });

    if (str.length > 0) {
      return '?' + str.join('&');
    } else {
      return '';
    }
  },
  parse(string = '') {
    if (typeof string !== 'string') {
      return {};
    }
    if (string.charAt(0) === '?') {
      string = string.substr(1);
    }
    var queryObj = {};
    var pieces = string.split('&');
    pieces.forEach((piece) => {
      var splitPiece = piece.split('=');
      var name = splitPiece[0];
      var value = splitPiece[1];
      if (value === 'true') {
        value = true;
      }
      if (value === 'false') {
        value = false;
      }
      queryObj[name] = value;
    });

    return queryObj;
  },
  safeJsonStringify(obj) {
    return JSON.stringify(obj)
      .replace(/<\/script/g, '<\\/script')
      .replace(/<!--/g, '<\\!--');
  },
  updateQueryStringFromLocation(pathname, search, updateQueryObj) {
    // remove ? from search
    const oldQueryObj = queryUtil.parse(search.substring(1));

    // merge old and new queries
    const newQueryObj = assign({}, oldQueryObj, updateQueryObj);

    return `${pathname}${queryUtil.stringify(newQueryObj)}`;
  },
};

export default queryUtil;
